/* 🤖 this file was generated by svg-to-ts */
export const DfIconCheckmarkCircle12: {
  name: 'checkmark-circle-12';
  data: string;
} = {
  name: 'checkmark-circle-12',
  data: `<svg viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm3.426 3.431a.951.951 0 0 0-1.252.044L4.764 6.83 3.8 6l-.049-.044A.951.951 0 0 0 2.5 6l-.025.025a.841.841 0 0 0 0 1.225l1.64 1.492.048.045c.168.14.379.21.59.213l.091-.003a.92.92 0 0 0 .57-.255L9.5 4.725a.841.841 0 0 0 0-1.225Z"/></svg>`
};
